// Helper function to escape special regex characters
export const escapeRegExp = (str: string): string => {
  return str.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
};

export const processTextWithKeywords = (text: string, keywords?: string[]): string => {
  if (!keywords?.length || !text) return text;

  let processedText = text;
  const validKeywords = keywords.filter(
    keyword => keyword && typeof keyword === "string"
  );
  validKeywords.sort((a, b) => b.length - a.length);

  for (const keyword of validKeywords) {
    const regex = new RegExp(`\\b(${escapeRegExp(keyword)})\\b`, "gi");
    processedText = processedText.replace(regex, "**$1**");
  }

  return processedText;
};
